<template>
    <div class="border rounded-lg bg-white shadow px-4 py-3">
        <h5>Select your quote currency</h5>
        <div class="my-3">
            <p>The buyer has selected a base currency for this quote, but you can quote prices a currency of your choice, from the options below.</p>
            <p>If you select a currency different from the base currency, we will display your quoted prices in both currencies as you enter them, and when the buyer is reviewing them.</p>
            <p>The exchange rates are based on the latest available market data, usually updated within the last hour.</p>
        </div>
        <h6 class="mb-0">Currency Options:</h6>
        <div class="p-3">
            <b-list-group v-if="optionsReady" key="showOptions" class="">
                <b-list-group-item
                    v-for="curr in currencies"
                    :key="curr.code"
                    button
                    @click="startSelection(curr)"
                    class="text-center font-weight-bold"
                >{{ curr.code }} - {{ curr.name }}</b-list-group-item>
            </b-list-group>
            <div v-else-if="savingCurrency" key="savingCurrency" class="">
                <busy-spinner text="Saving your selection..."></busy-spinner>
            </div>
            <div v-else key="loadingOptions" class="">
                <busy-spinner></busy-spinner>
            </div>
        </div>
        <!-- <div class="my-3">
            <hr>
            <p>quoted_currency: {{ quoted_currency }}</p>
            <h6>Exchange Rate Data:</h6>
            <pre>{{ exchangeRateData }}</pre>
        </div> -->

    </div>
</template>

<script>
import { errorHandling } from "../../js/custom-vue-mixins";
import { suppliosApi } from "../../js/api-service";

export default {
    name: "QuoteSheetReplyCurrencyPicker",
    components: {},
    mixins: [errorHandling],
    props: {
        replyId: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            initialReplyLoaded: false,  // one-way flag for initial load complete
            loadingReply: false,  
            replyData: {},  // QuoteSheetReply data? -- for getting quoted_currency and exchangeRateData
            initialCurrenciesLoaded: false,  // one-way flag for initial load complete
            loadingCurrencies: false,
            currencies: [],  // list of currency options { code, name } maybe add rate later
            savingCurrency: false,
            quoted_currency: '',  // will be the currency code if there is one selected? 
            exchangeRateData: {},  // serialized ExchangeRateData if we have quoted_currency set
        };
    },
    computed: {
        optionsReady() {
            return this.initialReplyLoaded && this.initialCurrenciesLoaded && !this.loadingReply && !this.loadingCurrencies;
        }
    },
    mounted() {
        this.getReply();
        this.getCurrencies();
    },
    methods: {
        async getReply() {
            this.loadingReply = true;
            let resp;
            try {
                resp = await suppliosApi.quoteSheetReply.retrieve(this.replyId);
            } catch (error) {
                this.apiErrorHandler(error);
            }
            if (resp?.data) {
                this.replyData = {...resp.data};
                this.quoted_currency = resp.data.quoted_currency || '';
                this.exchangeRateData = resp.data.exchange_rate_data || {};
            }
            this.initialReplyLoaded = true;
            this.loadingReply = false;
        },
        async getCurrencies() {
            this.loadingCurrencies = true;
            try {
                const { data } = await suppliosApi.quoteSheetReply.get_currency_data_for_selection(this.replyId);
                this.currencies = data ? [...data] : [];
            } catch (error) {
                this.apiErrorHandler(error);
            }
            this.initialCurrenciesLoaded = true;
            this.loadingCurrencies = false;
        },
        async refreshList() {
            return await this.getCurrencies();
        },
        async startSelection(currencyObj) {
            const currencyCode = currencyObj.code;
            const currencyName = currencyObj.name;
            console.log('set currency code', currencyCode);
            const isConfirmed = await this.$bvModal.msgBoxConfirm(`Provide your quoted prices in ${currencyCode} (${currencyName})?  You will not be able to change it later.`, {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes, Confirm',
                cancelTitle: 'No, Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            });
            if (isConfirmed) {
                this.performSelection(currencyObj);  // just trigger it and go
            }
        },
        async performSelection(currencyObj) {
            this.savingCurrency = true;
            const postData = {
                currency: currencyObj.code,
            };
            try {
                await suppliosApi.quoteSheetReply.set_quoted_currency(this.replyId, postData);
            } catch (error) {
                this.apiErrorHandler(error);
            }
            this.$emit('updated', currencyObj);  
            this.refreshList();  // just trigger it and go  TODO TODO TODO - emit?
            this.savingCurrency = false;
        },
    }
}
</script>

<style>

</style>